// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3oKIg","messages":"Chat_messages__3FHdp","dateDivider":"Chat_dateDivider__1EeU1"};